import { render, staticRenderFns } from "./import.vue?vue&type=template&id=0fc17bf2&scoped=true"
import script from "./import.vue?vue&type=script&lang=ts"
export * from "./import.vue?vue&type=script&lang=ts"
import style0 from "./import.vue?vue&type=style&index=0&id=0fc17bf2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc17bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc17bf2')) {
      api.createRecord('0fc17bf2', component.options)
    } else {
      api.reload('0fc17bf2', component.options)
    }
    module.hot.accept("./import.vue?vue&type=template&id=0fc17bf2&scoped=true", function () {
      api.rerender('0fc17bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients-contacts/import.vue"
export default component.exports